export enum MapMarkerType {
	USER,
	BUILDING,
	SERVICE,
	COUPLING,
}
